import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./Tooltip.scss";

// Styles Mostly from Bootstrap
const TooltipInnerStyle = {
  padding: "20px 50px",
  color: "#000",
  textAlign: "center",
  borderRadius: 3,
  backgroundColor: "#FFF",
};

const TooltipArrowStyle = {
  position: "absolute",
  width: 0,
  height: 0,
  borderRightColor: "transparent",
  borderLeftColor: "transparent",
  borderTopColor: "transparent",
  borderBottomColor: "transparent",
  borderStyle: "solid",
};
const arrowSize = 10;
const PlacementStyles = {
  left: {
    tooltip: { marginLeft: -3, padding: "0 5px" },
    arrow: {
      right: 0,
      marginTop: -5,
      borderWidth: `${arrowSize}px 0 ${arrowSize}px ${arrowSize}px`,
      borderLeftColor: "#FFF",
    },
  },
  right: {
    tooltip: { marginRight: 3, padding: "0 5px" },
    arrow: {
      left: 0,
      marginTop: -5,
      borderWidth: `${arrowSize}px ${arrowSize}px ${arrowSize}px 0`,
      borderRightColor: "#FFF",
    },
  },
  top: {
    tooltip: { marginTop: -3, padding: "5px 0" },
    arrow: {
      bottom: 0,
      marginLeft: -5,
      borderWidth: `${arrowSize}px ${arrowSize}px 0`,
      borderTopColor: "#FFF",
    },
  },
  bottom: {
    tooltip: { marginBottom: 0, padding: 0, top: 45 },
    arrow: {
      top: 0,
      marginTop: -10,
      borderWidth: `0 ${arrowSize}px ${arrowSize}px`,
      borderBottomColor: "#c5c5c5",
    },
  },
};

function Tooltip({ ...props }) {
  const placementStyle = PlacementStyles[props.placement];
  const {
    arrowOffsetLeft: left = placementStyle.arrow.left,
    arrowOffsetTop: top = placementStyle.arrow.top,
    children,
  } = props;
  return (
    <div className={classnames("wbkv9-Tooltip-Container", styles.container)}>
      <div
        className={classnames("wbkv9-Tooltip-Arrow", styles.arrow, styles[props.placement])}
        style={{ ...TooltipArrowStyle, ...placementStyle.arrow, left, top }}
      />
      <div
        className={classnames("wbkv9-Tooltip-Content", styles.content)}
        style={TooltipInnerStyle}>
        {children}
      </div>
    </div>
  );
}

Tooltip.propTypes = {
  placement: PropTypes.string,
  customStyle: PropTypes.object,
  arrowOffsetLeft: PropTypes.object,
  arrowOffsetTop: PropTypes.object,
  children: PropTypes.object,
};

export default Tooltip;
